export default {
    meta: {
        title: '拓店宝-选择审批人',
    },
};
